export default "__VITE_ASSET__CEoHfTLj__"